import { render, staticRenderFns } from "./CollectionsIdentificationHeader.vue?vue&type=template&id=ab8ba058&scoped=true"
import script from "./CollectionsIdentificationHeader.vue?vue&type=script&lang=js"
export * from "./CollectionsIdentificationHeader.vue?vue&type=script&lang=js"
import style0 from "./CollectionsIdentificationHeader.vue?vue&type=style&index=0&id=ab8ba058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8ba058",
  null
  
)

export default component.exports